import { asyncAction } from 'lib/actionCreators'

export const notificationsList = asyncAction('NOTIFICATIONS_LIST')
export const newNotificationsList = asyncAction('EMPTY_NOTIFICATIONS_LIST')
export const unreadNotificationsSocket = asyncAction('UNREAD_NOTIFICATIONS_SOCKET')
export const unreadNotifications = asyncAction('UNREAD_NOTIFICATIONS')
export const notificationsAsViewed = asyncAction('NOTIFICATIONS_AS_VIEWED')
export const socketNotification = asyncAction('SOCKET_NOTIFICATION')
